import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import TextField from "./common/TextField";
import Select from "./common/Select";
import DatePicker from "./common/DatePicker";
import Checkbox from "./common/Checkbox";
import logo from "../images/header.jpg";

import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";

const styles = {
    appLogo: {
        width: 200,
        cursor: "pointer"
    }
};

function MAKE_OPTIONS(table) {
    return table.map(row => ({
        label: row,
        value: row
    }));
}

class HomePage extends Component {
    state = {
        reason: null,
        service_not: false,
        submitted: false,
        loading: false
    };

    submitForm = values => {
        this.setState({loading: true});
        fetch("/contact/submission.php", {
            method: "POST",
            body: JSON.stringify(values)
        }).then(e => {
            if (e.status === 500) {
                alert("Error during submission");
            } else {
                this.setState({submitted: true});
            }
            this.setState({loading: false});
        });
    };

    errorValidator = values => {
        const validateEmail = email => {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !re.test(email) ? "Invalid email address." : null;
        };
        const validateName = value => {
            return !value ? "This field is required." : null;
        };

        const objErrors = {
            first_name: validateName(values.first_name),
            last_name: validateName(values.last_name),
            email: validateEmail(values.email),
            reason: validateName(values.reason),
        };
        if (values.reason !== "Request Presentation" && values.reason !== "Tick Question or Report" && values.reason !== "Other Questions or Concerns") {
            objErrors["full_address"] = validateName(values.full_address);
            if (values.service_location_not)
                objErrors["service_full_address"] = validateName(values.service_full_address);
        }

        return objErrors;
    };

    render() {
        const { classes } = this.props;
        const { reason, service_not, submitted, loading } = this.state;

        if (submitted) {
            return (
                <div>
                    <AppBar position="fixed" color="transparent">
                        <Toolbar>
                            <a href="https://mmcd.org">
                                <img src={logo} alt="Metropolitan Mosquito Control District Logo" className={classes.appLogo} />
                            </a>
                        </Toolbar>
                    </AppBar>
                    <Grid container spacing={2} justify="center" style={{marginTop:70}}>
                        <Grid item xs={12} lg={9}>
                            <Typography variant="h4" gutterBottom style={{textAlign: "center", marginBottom: 20}}>
                                Metropolitan Mosquito Control District Contact Form
                            </Typography>
                            <Typography>
                                Thank you! Your inquiry has been successfully submitted. A confirmation has been sent to
                                the e-mail address you provided.
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            );
        }

        if (loading) {
            return (
                <div>
                    <AppBar position="fixed" color="transparent">
                        <Toolbar>
                            <a href="https://mmcd.org">
                                <img src={logo} alt="Metropolitan Mosquito Control District Logo" className={classes.appLogo} />
                            </a>
                        </Toolbar>
                    </AppBar>
                    <Grid container spacing={2} justify="center" style={{marginTop:70}}>
                        <Grid item xs={12} lg={9} style={{textAlign: "center"}}>
                            <Typography variant="h4" gutterBottom style={{textAlign: "center", marginBottom: 20}}>
                                Metropolitan Mosquito Control District Contact Form
                            </Typography>
                            <CircularProgress size={100} thickness={1.5} />
                            <Typography>Saving... Please Wait</Typography>
                        </Grid>
                    </Grid>
                </div>
            );
        }

        return (
            <div>
                <AppBar position="fixed" color="transparent">
                    <Toolbar>
                        <a href="https://mmcd.org">
                            <img src={logo} alt="Metropolitan Mosquito Control District Logo" className={classes.appLogo} />
                        </a>
                    </Toolbar>
                </AppBar>
                <Grid container spacing={2} justify="center" style={{marginTop:70}}>
                    <Grid item xs={12} lg={9}>
                        <Typography variant="h4" gutterBottom style={{textAlign: "center", marginBottom: 20}}>
                            Metropolitan Mosquito Control District Contact Form
                        </Typography>
                        <Form
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            getApi={el => (this.formApi = el)}
                            validateError={this.errorValidator}
                            onSubmit={this.submitForm}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="h5" gutterBottom>
                                                Contact Information:
                                            </Typography>
                                            <TextField field="first_name" label="First Name (Required)" fullWidth />
                                            <TextField field="last_name" label="Last Name (Required)" fullWidth />
                                            <TextField field="company_name" label="Company Name" fullWidth />
                                            <TextField field="email" label="E-Mail Address (Required)" fullWidth />
                                            <TextField maxLength={10} field="phone" placeholder="No dashes or spaces Ex: 6129990123" label="Telephone Number" fullWidth />
                                        </Grid>

                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="h5" gutterBottom>
                                                Contact Reason:
                                            </Typography>
                                            <Select
                                                field="reason"
                                                label="Reason for Contact"
                                                options={MAKE_OPTIONS([
                                                    "Report Mosquito Annoyance",
                                                    "Report Water-holding Area",  
                                                    "Request Tire Pick-up",  
                                                    "Request Treatment for Public Event",
                                                    "Report Biting Gnat Annoyance",
                                                    "Report a Dead Bird",  
                                                    "Report Helicopter Concern", 
                                                    "Request Presentation",
                                                    "Tick Question or Report",
                                                    "Other Questions or Concerns"
                                                ])}
                                                fullWidth
                                                eventHandle={(v) => this.setState({reason: v})}
                                            />
                                            {reason === "Report Water-holding Area" && (
                                                <Typography variant="caption">
                                                    If it is on our <a rel="noopener noreferrer" href={"https://" + window.location.host + "/?x=" + this.formApi.getValue("lat") + "&y=" + this.formApi.getValue("lng")} target="_blank">map</a>, help us find it by giving "sitecode" in your message.
                                                </Typography>
                                            )} 
                                            {reason === "Request Tire Pick-up" && (
                                                <Grid container>
                                                    <Grid item xs={1}>
                                                    </Grid>
                                                    <Grid item xs={11}>
                                                        <TextField field="tire_count" type="number" label="Count of Tires (if more than 50, please call 651-645-9149 instead)" fullWidth />
                                                    </Grid>
                                                </Grid>
                                            )} 
                                            {reason === "Request Treatment for Public Event" && (
                                                <Grid container>
                                                    <Grid item xs={1}>
                                                    </Grid>
                                                    <Grid item xs={11}>
                                                        <TextField field="event_description" label="Description" fullWidth />
                                                        <DatePicker
                                                            field="event_date"
                                                            label="Date"
                                                            fullWidth
                                                        />
                                                        <TextField field="event_time" label="Time" fullWidth />
                                                        <TextField field="event_duration" label="Duration" fullWidth />
                                                        <TextField field="event_size" label="Size Expected" fullWidth />
                                                    </Grid>
                                                </Grid>
                                            )} 
                                            {reason === "Report Helicopter Concern" && (
                                                <Typography variant="caption">
                                                    Please note the time in your message.
                                                </Typography>
                                            )} 
                                        </Grid>

                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="h5" gutterBottom>
                                                Your Address:
                                            </Typography>
                                            <TextField 
                                                eventHandle={(v, is_valid, address) => {
                                                    if (is_valid && reason !== "Request Presentation" && reason !== "Tick Question or Report" && reason !== "Other Questions or Concerns") {
                                                        if (address["administrative_area_level_2"]!== "Carver County" && 
                                                        address["administrative_area_level_2"] !== "Scott County" && 
                                                        address["administrative_area_level_2"] !== "Dakota County" && 
                                                        address["administrative_area_level_2"] !== "Hennepin County" && 
                                                        address["administrative_area_level_2"] !== "Ramsey County" && 
                                                        address["administrative_area_level_2"] !== "Anoka County" && 
                                                        address["administrative_area_level_2"] !== "Washington County") {
                                                            alert("Your address in not within MMCD's service area.");
                                                            this.formApi.setValue("full_address", null);
                                                            return;
                                                        }
                                                        this.formApi.setValue("house_number", address["street_number"]);
                                                        this.formApi.setValue("street", address["route"]);
                                                        this.formApi.setValue("city", address["locality"]);
                                                        this.formApi.setValue("state", address["administrative_area_level_1"]);
                                                        this.formApi.setValue("zip", address["postal_code"]);
                                                        this.formApi.setValue("lat", address["lat"]);
                                                        this.formApi.setValue("lng", address["lng"]);
                                                    }
                                                }}
                                                field="full_address" 
                                                label={
                                                    reason === "Request Presentation" || reason === "Tick Question or Report" || reason === "Other Questions or Concerns" ? "Type Address" : "Type Address (Required)" 
                                                } fullWidth useAutoComplete 
                                                helperText="(Please call 651-645-9149 if matching address cannot be found)" />
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="h5" gutterBottom>
                                                Address Requiring Service:
                                            </Typography>
                                            <Checkbox
                                                label="Check if Service Location is not your address."
                                                field="service_location_not"
                                                eventHandle={value => {
                                                    this.setState({service_not: value});
                                                }}
                                            />
                                            {service_not && (
                                                <TextField 
                                                    eventHandle={(v, is_valid, address) => {
                                                        if (is_valid) {
                                                            if (address["administrative_area_level_2"] !== "Carver County" && 
                                                            address["administrative_area_level_2"] !== "Scott County" && 
                                                            address["administrative_area_level_2"] !== "Dakota County" && 
                                                            address["administrative_area_level_2"] !== "Hennepin County" && 
                                                            address["administrative_area_level_2"] !== "Ramsey County" && 
                                                            address["administrative_area_level_2"] !== "Anoka County" && 
                                                            address["administrative_area_level_2"] !== "Washington County") {
                                                                alert("Your address in not within MMCD's service area.");
                                                                this.formApi.setValue("service_full_address", null);
                                                                return;
                                                            }
                                                            this.formApi.setValue("service_house_number", address["street_number"]);
                                                            this.formApi.setValue("service_street", address["route"]);
                                                            this.formApi.setValue("service_city", address["locality"]);
                                                            this.formApi.setValue("service_state", address["administrative_area_level_1"]);
                                                            this.formApi.setValue("service_zip", address["postal_code"]);
                                                            this.formApi.setValue("service_lat", address["lat"]);
                                                            this.formApi.setValue("service_lng", address["lng"]);
                                                        }
                                                    }}
                                                    field="service_full_address" 
                                                    label="Type Address (Required)" fullWidth useAutoComplete 
                                                    helperText="(Please call 651-645-9149 if matching address cannot be found)" />
                                                )}
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="h5" gutterBottom>
                                                Message:
                                            </Typography>
                                            <TextField field="message" multiline rows={8} label="Your Message" fullWidth />
                                        </Grid>
                                    </Grid>
                                    <Button type="submit" variant="contained" color="primary">
                                        Send
                                    </Button>
                                </form>
                            )}
                        </Form>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

HomePage = connect(
    state => ({ 
    }),
    {
    }
)(HomePage);

export default withStyles(styles)(withRouter(HomePage));
